export default class FraudHitEvaluatorStatusChangeItem {
  constructor(fraudHitEvaluatorIds) {
    this.initialize(fraudHitEvaluatorIds);
  }

  initialize(fraudHitEvaluatorIds) {
    this.FraudHitEvaluatorIds = fraudHitEvaluatorIds;
    this.FraudStatus = '';
    this.IsNewlyDetected = false;
  }
}
